import React, {useCallback} from "react";
import "./index.scss";
import {TextField} from "features/components/text-field";
import {__} from "services/i18n";
import {connect} from "react-redux";
import {bool, number, oneOf} from "prop-types";
import {Icon} from "features/components/icon";
import {RequiredValidator} from "services/utils/validations";
import {
    commentDataSelector,
    commentErrorSelector,
    commentLoadingSelector, commentShowAttachmentModalSelector
} from "features/components/comment-field/selectors";
import {commentSet, commentSetShowAttachmentModal, commentStart} from "features/components/comment-field/reducer";
import CommentAutosuggest from "features/components/comment-field/comment-autosuggest";
import {useMediaQuery, useOnClickOutside} from "services/utils/utils";
import {autosuggestCommentHide} from "features/components/comment-field/comment-autosuggest/reducer";
import {commentAutosuggestShouldHideSelector} from "features/components/comment-field/comment-autosuggest/selectors";
import {withToastManager} from "react-toast-notifications";
import {MOBILE_MEDIA_QUERY_THRESHOLD} from "constants.js";

/* istanbul ignore next */
const mapStateToProps = state => ({
    value: commentDataSelector(state),
    loading: commentLoadingSelector(state),
    autosuggest_hidden: commentAutosuggestShouldHideSelector(state),
    error: commentErrorSelector(state),
    show_attachment_modal: commentShowAttachmentModalSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    setValue: commentSet,
    doHideAutoSuggest: autosuggestCommentHide,
    commentStart,
    commentSetShowAttachmentModal
};


export const CommentField = (props) => {

    const {value, loading, setValue, doHideAutoSuggest, autosuggest_hidden,
        commentStart, type, resource_id, error, hide_send = false, enable_attachment = false,
        show_attachment_modal, commentSetShowAttachmentModal} = props;
    const outsideRef = React.useRef(null);
    /* istanbul ignore next */
    useOnClickOutside(outsideRef, () => {
        if(autosuggest_hidden) return;
        doHideAutoSuggest();
    });

    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD)

    React.useEffect(() => {
        if(!error.inError) return;
        props.toastManager.add(__(error.error), { appearance: 'error', id: 'error-post-comment-toast'});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    const doComment = useCallback(() => {
        if(!RequiredValidator(value)) return;
        commentStart({
            type: type,
            id: resource_id
        })
    }, [commentStart, resource_id, type, value]);

    const doOpenAttachment = useCallback(() => {
        commentSetShowAttachmentModal(true)
    }, [commentSetShowAttachmentModal]);

    return <div ref={outsideRef} className={`comment-field ${enable_attachment ? "attachment-enabled" : ""}`}>
        <TextField
            disabled={loading}
            type={"text"}
            value={value}
            onChange={setValue}
            placeholder={__(isMobile ? "common.do-comment" : `text-fields.comment-${type}.placeholder`)}
            backgroundWhite={true}
        />
        {(enable_attachment && !show_attachment_modal) && <div className={`attachment-btn`} onClick={doOpenAttachment}>
            <Icon>attachment</Icon>
        </div>}
        {(!hide_send && !show_attachment_modal) && <div className={`send-btn ${RequiredValidator(value) ? "valid" : ""}`} onClick={doComment}>
            <Icon>{loading ? "loader" : "send"}</Icon>
        </div>}
        <CommentAutosuggest />
    </div>
};
CommentField.propTypes = {
    type: oneOf(["event", "video", "thread"]).isRequired,
    resource_id: number.isRequired,
    hide_send: bool,
    enable_attachment: bool
};
export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(CommentField));